// extracted by mini-css-extract-plugin
export default {"amountContainer":"CurrencyInputGroup_amountContainer__vhR3i"};